export default "__VITE_ASSET__4Bf2jWR4__"